import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiClient } from "@/lib/api";

export default function CategoryPills({ value, onChange }) {
  const { t, i18n } = useTranslation();
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    apiClient.get("/categories").then(({ data }) => setCategories(data)).catch(() => {});
  }, [i18n.language]);

  const labelFor = (c) => {
    const key = `categories.${c.key}`;
    const translated = t(key);
    // If the key wasn't defined we fall back to the backend label
    return translated === key ? c.label : translated;
  };

  return (
    <div className="flex gap-3 overflow-x-auto no-scrollbar -mx-4 px-4 py-2">
      <button
        onClick={() => onChange(null)}
        data-testid="category-pill-all"
        className={`shrink-0 rounded-full px-4 py-2 text-sm font-medium border transition-all ${!value ? "bg-ink text-white border-ink" : "bg-white text-ink border-sand hover:border-brand-red"}`}
      >
        {t("categories.all")}
      </button>
      {categories.map((c) => (
        <button
          key={c.key}
          onClick={() => onChange(c.key)}
          data-testid={`category-pill-${c.key}`}
          className={`shrink-0 rounded-full px-4 py-2 text-sm font-medium border transition-all flex items-center gap-2 ${value === c.key ? "bg-ink text-white border-ink" : "bg-white text-ink border-sand hover:border-brand-red"}`}
        >
          <span className="text-base">{c.emoji}</span> {labelFor(c)}
        </button>
      ))}
    </div>
  );
}
